module.exports = __webpack_public_path__ + "img/half-rhombus-2.6f87c79e.svg";